import { isArray, isPlainObject } from 'lodash-es';
import moment, { Moment } from 'moment';

export type JsonPrimitive = null | boolean | number | string | JsonPrimitive[];

export type JsonObject = { [prop: string]: Json };

export type Json = JsonPrimitive | JsonObject | Json[];

export function isJsonArray(value: Json): value is Json[] {
    return isArray(value);
}

export function isJsonObject(value: unknown): value is JsonObject {
    return isPlainObject(value);
}

export function tryConvertISODate(value: string): Moment | string {
    const date = moment(value, moment.ISO_8601, true);

    return date.isValid() ? date : value;
}

export const isStringArray = (value: unknown): value is Array<string> =>
    Array.isArray(value) && value.filter((item: unknown) => typeof item !== 'string').length === 0;

export type IPlaceholders = Record<string, JsonObject>;
